import React, {Component} from 'react';
import Select from 'react-select';
import CssJs from "../../style/cssjs";


export class InputDropdown extends Component
{
    state = {
        itemSelected: null
    };


    componentDidMount() {
        const {selected} = this.props;
        this.setState({itemSelected: selected});
    }


    _handleChangeSelect = item => {
        this.setState({itemSelected: item});
        this.props.onChange(item);
    };


    render()
    {
        const {options, name, isMulti, className, menuPlacement, placeholder} = this.props;
        const {itemSelected} = this.state;

        return (
           <div className={`w-100 ${className}`}>
               <Select
                   name={name}
                   value={itemSelected}
                   onChange={this._handleChangeSelect}
                   options={options}
                   styles={CssJs.select}
                   isMulti={isMulti}
                   menuPlacement={menuPlacement ? menuPlacement : 'auto'}
                   placeholder={placeholder}
               />
           </div>
        );
    }
}
